const API_BASE_URL = process.env.REACT_APP_API_URL;
export type CareerTableRequest = FormData;
export const submitJobRequest = async (payload: FormData) => {
  debugger;

  const response = await fetch(`${API_BASE_URL}/createjobrequest`, {
    method: "POST",
    body: payload,
  });

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }

  return response.json();
};
